// Funktioner för eventlyssnare

import * as general from "./general.js";
import * as functions from "./functions.js";
import getInfoFromReg from "./helpers/get-info.js";

export function regnoListener(input) {
  if (input.srcElement !== undefined) {
    input = input.srcElement;
  }
  if (input.value.length >= 6 && input.value.length <= 7) {
    let infobox;
    if (input.parentElement.querySelectorAll(".vehicle-info").length > 0) {
      infobox = input.parentElement.querySelector(".vehicle-info");
    } else {
      infobox = document.createElement("div");
      infobox.classList.add("vehicle-info");
    }
    infobox.innerHTML = general.getLoader();
    let p = document.createElement("p");
    let error = false;
    getInfoFromReg(input.value)
      .then((value) => {
        if (value.brand && value.model) {
          p.innerHTML = value.brand + ", " + value.model;
          functions.addToUrl("regno", input.value);
        } else if (typeof value === "string" || value instanceof String) {
          p.innerHTML = value;
        } else {
          p.innerHTML = "Något gick fel, vänligen testa ett annat regnummer eller kontakta oss.";
        }
        infobox.innerHTML = p.outerHTML;
        if (typeof value === "object") {
          general.setInfo(value);
        } else {
          general.setInfo({});
          error = true;
        }
      })
      .then((value) => {
        input.parentNode.insertBefore(infobox, input.nextSibling);
        if (error) {
          functions.lockButtons();
        } else {
          functions.unlockButtons();
        }
      })
      .then(() => {
        document.dispatchEvent(new Event("carSet"));
      });
  } else if (input.parentElement.querySelectorAll(".vehicle-info").length > 0) {
    input.parentElement.querySelector(".vehicle-info").innerHTML = "";
    functions.lockButtons();
  }
}

export function facListener(radio) {
  radio = radio.srcElement;
  general.setChosenFacility(radio.value);
  if (document.querySelectorAll(".chosen").length > 0) {
    document.querySelector(".chosen").classList.remove("chosen");
  }
  radio.parentElement.parentElement.classList.add("chosen");
  functions.unlockButtons();
  functions.addToUrl("fac", radio.value);

  if (radio.dataset.extLink) {
    functions.activateExternalLink(radio.dataset.extLink, radio.dataset.extTitle);
  } else {
    functions.deactivateExternalLink();
  }
}

export function serviceListener(checkbox) {
  let unlock = true;
  checkbox = checkbox.srcElement;
  if (document.querySelectorAll(".services__service.chosen").length > 0) {
    const chosen = document.querySelector(".services__service.chosen");
    const chosenCheckbox = chosen.querySelector('input[type="checkbox"]');
    if (chosenCheckbox) {
      chosenCheckbox.checked = false;
    }
    chosen.classList.remove("chosen");

    const prevTextarea = chosen.querySelector("textarea");
    const prevMileage = chosen.querySelector("#mileage");
    const prevServiceCode = chosen.querySelector("#code");
    if (prevTextarea) {
      prevTextarea.disabled = true;
      prevTextarea.removeEventListener("input", textareaListener);
      // document.removeEventListener('pageChange', saveTextArea);
      general.setMessage("");
    }

    if (chosenCheckbox && chosenCheckbox.dataset.mileage === "true" && prevMileage) {
      prevMileage.disabled = true;
      prevMileage.removeEventListener("input", mileageListener);

      if (prevServiceCode) {
        prevServiceCode.disabled = true;
        prevServiceCode.removeEventListener("input", saveCode);
      }

      general.setMileage("");
      general.setServiceCode("");
    }
  }

  const parent = checkbox.parentElement.parentElement.parentElement;
  const textarea = parent.querySelector("textarea");
  const mileage = parent.querySelector("#mileage");
  const serviceCode = parent.querySelector("#code");
  if (checkbox.checked) {
    general.setChosenService(checkbox.value);
    functions.addToUrl("serv", checkbox.value);
    parent.classList.add("chosen");
    if (textarea) {
      textarea.disabled = false;
      textarea.addEventListener("input", textareaListener);
      unlock = false;
      general.setMessage(textarea.value);
    }

    if (checkbox.dataset.mileage === "true" && mileage) {
      unlock = false;
      mileage.disabled = false;
      mileage.addEventListener("input", mileageListener);
      if (serviceCode) {
        serviceCode.disabled = false;
        serviceCode.addEventListener("input", saveCode);
      }
    }
  } else {
    general.setChosenService("");
    functions.addToUrl("serv", "");
  }

  if (unlock && checkbox.checked) {
    functions.unlockButtons();
  } else {
    functions.lockButtons();
  }
}

export function textareaListener(textarea) {
  if (textarea.srcElement.value.length > 0) {
    functions.unlockButtons();
  } else {
    functions.lockButtons();
  }
  general.setMessage(textarea.srcElement.value);
}

export function mileageListener(input) {
  if (input.srcElement.value.length > 0 && !isNaN(parseFloat(input.srcElement.value))) {
    general.setMileage(parseFloat(input.srcElement.value));
    functions.unlockButtons();
  } else {
    functions.lockButtons();
  }
}

// export function saveTextArea() {
//     const parent = document.querySelector('.services__service.chosen');
//     general.setMessage(parent.querySelector('textarea').value);
// }

export function saveMileage() {
  const parent = document.querySelector(".services__service.chosen");
  if (parent && parent.querySelector("#mileage")) {
    general.setMileage(parent.querySelector("#mileage").value);
  } else {
  }
}

export function saveCode() {
  const parent = document.querySelector(".services__service.chosen");
  general.setServiceCode(parent.querySelector("#code").value);
}

export function serviceOpenerListener(opener) {
  opener = opener.srcElement;
  opener.parentElement.querySelector(".more").classList.toggle("visible");
}

export function addonListener(checkbox) {
  checkbox = checkbox.srcElement;
  const id = checkbox.parentElement.dataset.name;
  functions.addToUrl("add", id, true);
  general.setChosenAddons(general.getAddon(id));

  document.querySelectorAll('.addons__addon[data-name="' + id + '"]').forEach((addon) => {
    addon.classList.toggle("chosen");
    addon.querySelector('input[type="checkbox"]').checked = checkbox.checked;
  });
}

export function showMoreAddons(button) {
  button = button.srcElement;
  const parent = button.parentElement.parentElement;

  parent.querySelectorAll(".addons__addon--hideable").forEach((addon) => {
    addon.classList.toggle("hidden");
  });

  if (button.textContent === "Visa fler") {
    button.textContent = "Visa färre";
  } else {
    button.textContent = "Visa fler";
  }
}

export function timeListener(time) {
  document.querySelectorAll(".timeslots__time").forEach((chosen) => {
    chosen.classList.remove("chosen");
  });
  const morning = {
    productId: 0,
    name: "Lämnas på morgonen",
    slug: "morgon",
    price: 0,
    short_desc: "",
    long_desc: "",
    addonPackage: true,
    resourceDemand: 0,
    info_req: false,
    loanerCar: false,
    morning: true,
  };
  const before = {
    productId: 0,
    name: "Lämnas dagen innan",
    slug: "dagen-innan",
    price: 0,
    short_desc: "",
    long_desc: "",
    addonPackage: true,
    resourceDemand: 0,
    info_req: false,
    loanerCar: false,
    before: true,
  };

  if (time.srcElement) {
    time = time.srcElement.parentElement;
    time.classList.add("chosen");
    functions.unlockButtons();
    general.setChosenDate(time.dataset.date);

    if (time.dataset.morning !== undefined) {
      general.setChosenAddons(morning);
      general.removeChosenAddons(before);
    } else {
      general.removeChosenAddons(morning);
    }

    if (time.dataset.before !== undefined) {
      general.setChosenAddons(before);
      general.removeChosenAddons(morning);
    } else {
      general.removeChosenAddons(before);
    }
  }
}

export function timeOpener(opener) {
  opener = opener.srcElement;
  opener.parentElement.parentElement.querySelector(".more").classList.toggle("visible");
}

export async function clickEvent(date) {
  functions.lockButtons();
  functions.removeFromUrl("date");

  const block = document.querySelector(".kobra-block");
  block.querySelector("#timeslot_target").innerHTML = general.getLoader(true);
  if (window.innerWidth < 600) {
    block.querySelector("#timeslot_target").scrollIntoView({ block: "center", behavior: "smooth" });
  }

  const form = new FormData();
  form.append("action", "nobox_get_times");
  form.append("regno", general.getInfo().regno);
  form.append("date", date[0]);
  form.append("key", general.getKey());
  form.append("resources", general.getTotalTime());
  const params = new URLSearchParams(form);

  if (document.querySelectorAll(".clickable--clicked").length > 0) {
    document.querySelector(".clickable--clicked").classList.remove("clickable--clicked");
  }
  if (date[1]) {
    date[1].classList.add("clickable--clicked");
  }

  let events;
  await fetch(horizon.ajaxUrl, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Cache-Control": "no-cache",
    },
    body: params,
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.html) {
        if (block.querySelector("#timeslot_target")) {
          block.querySelector("#timeslot_target").innerHTML = data.html;
        }
      }
      if (data.times) {
        general.setAvailableTimes(data.times);
      }
    })
    .then((data) => {
      document.querySelectorAll(".timeslots__time").forEach((time) => {
        time.addEventListener("change", timeListener);

        if (time.querySelectorAll(".readmore").length > 0) {
          time.querySelector(".readmore").addEventListener("click", timeOpener);
        }
      });
      document.querySelector('.timeslots__time input[type="radio"]').focus();
    });
}

export function formListener(e) {
  window.dataLayer = window.dataLayer || [];
  event.preventDefault();
  const form = e.srcElement;
  form.parentElement.classList.add("order-loading");

  const preference = form.querySelector('input[name="prefered_contact"]:checked').value;
  const first = form.querySelector("#firstname");
  const last = form.querySelector("#lastname");
  const email = form.querySelector("#email");
  const phone = form.querySelector("#phone");
  const campaign = form.querySelector("#campaign");

  first.classList.remove("error");
  last.classList.remove("error");
  email.classList.remove("error");
  phone.classList.remove("error");
  campaign.classList.remove("error");

  if (!first.value || first.value == "") {
    first.classList.add("error");
  } else if (!last.value || last.value == "") {
    last.classList.add("error");
  } else if (!email.value || email.value == "" || !email.value.includes("@") || !email.value.includes(".")) {
    email.classList.add("error");
  } else if (!phone.value || phone.value == "") {
    phone.classList.add("error");
  } else {
    const order = functions.createOrder(form); // Skapar ordern
    functions.createOrderSummary(order);
    if (order) {
      functions.sendOrder(order).then((resp) => {
        if (resp === "success") {
          form.parentElement.parentElement.parentElement.classList.add("order-confirmed");
          form.parentElement.classList.add("order-confirmed");
          form.parentElement.classList.remove("order-loading");

          // GTM DataLayer
          window.dataLayer.push({ event: "confirmed" });
        }
      });

      document.querySelector("#progress_bar #bar").style.width = "100%";
    }
  }
}

export function editListener(e) {
  if (e) {
    general.setCurrentPage(parseInt(e.srcElement.dataset.page));
    document.dispatchEvent(new Event("pageChange"));
    document.querySelector(".order_confirmation").classList.toggle("visible");
    document.querySelector(".page__footer").classList.toggle("open");
  }
}

export function stepListener(e) {
  e.preventDefault();
  if (e) {
    const step = parseInt(e.srcElement.dataset.step);
    if (step === parseInt(general.getCurrentPage())) return false;

    const info = general.getInfo();
    const facility = general.getChosenFacility();
    const service = general.getChosenService();
    let serviceCode, serviceMessage;
    if (service && service.info_req) {
      serviceCode = general.getServiceCode();
      serviceMessage = general.getMessage();
    }
    const date = general.getChosenDate();

    const step1 = info && info.regno && info.brand && info.model && info.type ? true : false;
    const step2 = facility && facility.key && facility.title ? true : false;
    const step3 =
      service &&
      !isNaN(service.productId) &&
      service.name &&
      !isNaN(service.price) &&
      service.resourceDemand &&
      ((service.info_req && ((serviceCode && serviceCode !== "") || (serviceMessage && serviceMessage !== ""))) ||
        !service.info_req)
        ? true
        : false;
    const step5 = date !== undefined;

    if (step === 1) {
      general.setCurrentPage(1);
      document.dispatchEvent(new Event("pageChange"));
    } else if (step === 2 && step1) {
      general.setCurrentPage(2);
      document.dispatchEvent(new Event("pageChange"));
    } else if (step === 3 && step1 && step2) {
      general.setCurrentPage(3);
      document.dispatchEvent(new Event("pageChange"));
    } else if (step === 4 && step1 && step2 && step3) {
      general.setCurrentPage(4);
      document.dispatchEvent(new Event("pageChange"));
    } else if (step === 5 && step1 && step2 && step3) {
      general.setCurrentPage(5);
      document.dispatchEvent(new Event("pageChange"));
    } else if (step === 6 && step1 && step2 && step3 && step5) {
      general.setCurrentPage(6);
      document.dispatchEvent(new Event("pageChange"));
    } else {
      return false;
    }
  }
}

export function dateRequest(e) {
  if (e.srcElement.value.length > 0) {
    general.setChosenDate(e.srcElement.value);
    functions.unlockButtons();
  } else {
    general.setChosenDate("");
    functions.lockButtons();
  }
}
